import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { Excelsior_Title } from '../../../../../utils/ES/Modals/SpotsModals';

const ModalExcelsior = () => {
  return (
    <>
      <ModalVideo
        id="spot-excelsior"
        dataText={Excelsior_Title}
        videoSrc="https://player.vimeo.com/video/127517882?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
        videoTitle="KUTER_STUDIO_EXCELSIOR"
      />
    </>
  );
};

export default ModalExcelsior;
